export const PREORDER_INVENTORY = 'PRE_ORDER'
export const NORMAL_INVENTORY = 'NORMAL'

export const SHOPIFY_API = 'SHOPIFY_API'
export const INTERNAL_INVENTORY_API = 'INTERNAL_INVENTORY_API'

export type InventoryType = typeof PREORDER_INVENTORY | typeof NORMAL_INVENTORY
export type InventoryInfoSourceType = typeof SHOPIFY_API | typeof INTERNAL_INVENTORY_API

export interface ShopifyVariantDetails {
  id: number
  quantityAvailable: number
  price: number
  inventoryType?: InventoryType
  preOrderShippingDate?: string
  inventoryInfoSource: InventoryInfoSourceType
}

export interface IProductPurchaseInfo {
  shopifyVariantIdShowMTOMap: Record<number, boolean>
  shopifyVariantIdVsShopifyVariantInfo: Record<number, ShopifyVariantDetails>
}
